import { Trans } from "react-i18next";

import util from "utils/utils";

import FormattedComment from "components/lib/FormattedComment";

import type { NotificationContentProps } from "../../types";

export default function DiscussionRepliedContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.groupDiscussionReplied"
      values={{
        name: util.getEventNames(events ?? []),
        group: ownerGroup?.name || "Deleted",
        comment: events[0]?.comment || "",
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink maxLength={100} />,
      }}
    />
  );
}
